import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { NgbNav, NgbTypeaheadConfig } from "@ng-bootstrap/ng-bootstrap";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, map } from "rxjs";
import { CustomerService } from "src/app/services/customer.service";
import { GeoService } from "src/app/services/geo.service";
import { RateUploadService } from "src/app/services/operations/rateupload.service";
import { ProductService } from "src/app/services/products.service";
import { VendorService } from "src/app/services/vendor.service";
import { AppCoreService } from "src/app/services/app-core.service";
import { ExcelService } from "src/app/services/excel.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Title } from "@angular/platform-browser";
import { Utilities } from "src/app/models/utilities";

@Component({
    selector: 'app-ratecompare',
    templateUrl: './ratecompare.component.html',
    styleUrls: ['./ratecompare.component.scss']
})
export class RateCompareComponent implements OnInit, AfterViewInit {
    rateCompareForm: FormGroup;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    isFormSubmitted = false;
    typeList = [{ name: 'International' }, { name: 'Domestic' }];
    defaultType = this.typeList[0].name;
    customerList: any[] = [];
    vendorList: any[] = [];
    serviceList: any[] = [];
    shipmentTypeList = [{ name: 'DOX' }, { name: 'NDOX' }];
    productList: any[] = [];
    countryList: any[] = [];
    originStateList: any[] = [];
    originCityList: any[] = [];
    originPincodeList: any[] = [];
    destinationStateList: any[] = [];
    destinationCityList: any[] = [];
    destPincodeList: any[] = [];
    countryCode: any;
    filteredProductList: any[];
    activeId: any = 1;
    searchtype = 'All';
    @ViewChild('justifiednav') justifiednav: NgbNav;

    context: any;
    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: false,
        flex: 1,
        minWidth: 120
    };

    gridOptions: GridOptions = {
        pagination: true,
        domLayout: 'autoHeight',
        paginationPageSize: 10
    }
    rowData: any[] = [];
    columnDefs = [
        { headerName: 'Rates', field: 'rate', minWidth: 80, pinned: 'left' },
        { headerName: 'Other Charges', field: 'total_otherchargesamount', minWidth: 130, pinned: 'left' },
        { headerName: 'Fuel', field: 'total_fuel', minWidth: 70, pinned: 'left' },
        { headerName: 'Tax', field: 'taxamount', minWidth: 65, pinned: 'left' },
        { headerName: 'Grand Total', field: 'grandtotal', pinned: 'left' },
        { headerName: 'Weight', field: 'weight', minWidth: 90, pinned: 'left' },
        { headerName: 'Product', field: 'product' },
        { headerName: 'Vendor', field: 'vendor' },
        { headerName: 'Service', field: 'service' },
        { headerName: 'Origin Country', field: 'origincountry', minWidth: 160 },
        { headerName: 'Origin State', field: 'originstate', minWidth: 150 },
        { headerName: 'Origin City', field: 'origincity', minWidth: 130 },
        { headerName: 'Destination Country', field: 'destinationcountry', minWidth: 160 },
        { headerName: 'Destination State', field: 'destinationstate', minWidth: 150 },
        { headerName: 'Destination City', field: 'destinationcity', minWidth: 130 },
        { headerName: 'Zone', field: 'zone', minWidth: 75 },


    ];
    useEnterKey: any;
    rateComparePermissions: any = { customerratecompare: false, vendorratecompare: false };
    constructor(
        private formBuilder: FormBuilder,
        private appCoreService: AppCoreService,
        private customerService: CustomerService,
        private vendorService: VendorService,
        private productService: ProductService,
        private geoService: GeoService,
        private rateUploadService: RateUploadService,
        private typeaheadConfig: NgbTypeaheadConfig,
        private excelService: ExcelService,
        private ngxLoaderService: NgxUiLoaderService,
        private titleService: Title,
        private utilities: Utilities,
    ) {
        titleService.setTitle('Rate Compare');
        typeaheadConfig.selectOnExact = true;
        this.context = { componentParent: this };
    }

    ngOnInit(): void {
        // set full width for this page 
        const bodyTag = document.body;
        bodyTag.classList.add('sidebar-enable')
        bodyTag.classList.add('vertical-collpsed');

        this.rateCompareForm = this.formBuilder.group({
            rateFor: ['Customer'],
            ddlCustomer: [],
            ddlVendor: [],
            ddlService: [],
            ddlShipmentType: [],
            ddlProduct: [],
            ddlOriginCountry: [],
            ddlOriginState: [],
            ddlOriginCity: [],
            ddlDestinationCountry: [[], Validators.required],
            ddlDestinationState: [],
            ddlDestinationCity: [],
            txtOriginPincode: [],
            txtDestPincode: [],
            txtActualWeight: [[], [Validators.required]],
            txtVolumetricWeight: [],
        });
        this.checkPermission();
        if (this.permConfig.isViewAllowed) {
            this.getAllVendors();
            this.getAllCustomers();
            this.getAllProducts();
            this.bindCountries();
        }
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.rateCompareForm) : null;
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        const permission = userData.config.filter(x => x.categoryname === 'Compare');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }

        // Compare permissions
        const rateCompareCategories = ['CustomerRateCompare', 'VendorRateCompare'];
        const operationModules = userData.config.filter(x => x.parentcategoryname === 'Operations');
        const getPermission = (category, permissions) => {
            const permission = permissions.find(x => x.categoryname === category);
            return permission ? permission.view || false : false;
        };
        rateCompareCategories.forEach(category => {
            this.rateComparePermissions[category.toLowerCase()] = getPermission(category, operationModules);
        });

        this.applyPermissionsOverRateFor();
    }

    applyPermissionsOverRateFor() {
        const rateForControl = this.rateCompareForm.get('rateFor');
        const { customerratecompare, vendorratecompare } = this.rateComparePermissions;

        if (customerratecompare && vendorratecompare) {
            rateForControl.setValue('Customer');
        } else if (vendorratecompare) {
            rateForControl.setValue('Vendor');
        } else {
            rateForControl.disable();
            this.rateCompareForm.get('ddlCustomer').reset();
            this.rateCompareForm.get('ddlCustomer').disable();
        }
    }

    getAllCustomers() {
        try {
            this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
                this.customerList = res?.data;
                // this.customerList?.length
                //     ? (this.rateCompareForm.get('ddlCustomer').setValue(this.customerList.find(x => x.id === this.appCoreService.GetUserData()?.metaInfo?.customerid)?.id),
                //         this.rateCompareForm.get('ddlCustomer').disable()
                //     )
                //     : null;
            })
        } catch (e) {
            console.error(e);
        }
    }

    getAllVendors() {
        try {
            this.vendorService.GetAll({ isactive: true }).subscribe((res) => {
                if (res && res.success) {
                    this.vendorList = res.data;
                }
            })
        } catch (e) {
            console.error(e);
        }
    }

    getAllProducts() {
        try {
            this.productService.GetAll({ isactive: true }).subscribe((res) => {
                if (res && res.success) {
                    this.productList = res.data;
                    this.filteredProductList = this.productList;
                }
            })
        } catch (e) {
            console.error(e);
        }
    }

    getAllVendorServices(vendorid?: any, vendorChanged?: any) {
        if (vendorid) {
            if (vendorChanged)
                this.rateCompareForm.controls.ddlService.reset();
            try {
                this.vendorService.GetAllListByVendor({ id: vendorid }).subscribe((res) => {
                    if (res && res.success) {
                        this.serviceList = res.data;
                    }
                })
            } catch (e) {
                console.error(e);
            }
        }
    }

    onCountryChange(origin?) {
        let countryCode: any;
        if (origin) {
            countryCode = this.rateCompareForm.get('ddlOriginCountry').value;
            this.rateCompareForm.controls.ddlOriginState.reset();
            this.rateCompareForm.controls.ddlOriginCity.reset();
            this.originCityList = [];
            this.bindStatesByCountry(countryCode, origin);
        }
        else {
            countryCode = this.rateCompareForm.get('ddlDestinationCountry').value;
            this.rateCompareForm.controls.ddlDestinationState.reset();
            this.rateCompareForm.controls.ddlDestinationCity.reset();
            this.destinationCityList = [];
            this.bindStatesByCountry(countryCode);
        }
    }

    bindCountries() {
        const userData = this.appCoreService.GetUserData();
        const operationType = userData?.metaInfo?.operationtype || [];
        const defaultCountry = userData?.metaInfo?.defaultcountry;
        try {
            this.geoService.GetAllCountries().subscribe((res) => {
                if (res && res.success) {
                    this.countryList = operationType.includes('International') ? res.data : res.data.filter(country => country.isocode === defaultCountry);
                    if (!operationType.includes('International')) {
                        ['ddlDestinationCountry', 'ddlOriginCountry'].forEach(field => {
                            this.rateCompareForm.get(field)?.setValue(defaultCountry);
                            this.rateCompareForm.get(field)?.disable();
                        });
                        this.bindStatesByCountry(defaultCountry, 'origin');
                        this.bindStatesByCountry(defaultCountry);
                    }
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    bindStatesByCountry(countryCode?: string, type?: any) {
        try {
            if (countryCode) {
                this.geoService.GetAllStates({ countrycode: countryCode }).subscribe((res) => {
                    if (res && res.success) {
                        this.countryCode = countryCode;
                        this[type === 'origin' ? 'originStateList' : 'destinationStateList'] = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    onStateChange(origin?) {
        let countryCode: any;
        if (origin) {
            countryCode = this.rateCompareForm.get('ddlOriginState').value;
            this.rateCompareForm.controls.ddlOriginCity.reset();
            this.bindCitiesByState(countryCode, origin);
        }
        else {
            countryCode = this.rateCompareForm.get('ddlDestinationState').value;
            this.rateCompareForm.controls.ddlDestinationCity.reset();
            this.bindCitiesByState(countryCode);
        }
    }

    bindCitiesByState(stateCode?: string, type?: any) {
        try {
            if (stateCode) {
                this.geoService.GetAllCities({ statecode: stateCode }).subscribe((res) => {
                    if (res && res.success) {
                        this[type === 'origin' ? 'originCityList' : 'destinationCityList'] = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    applySwitchSelectedRateFor() {
        const rateFor = this.rateCompareForm.get('rateFor').value;

        switch (rateFor) {
            case 'Customer':
                this.rateCompareForm.get('ddlCustomer')?.enable();
                // Determine the search type based on the state of ddlCustomer and ddlVendor
                const hasCustomer = !!this.rateCompareForm.get('ddlCustomer')?.value;
                const hasVendor = !!this.rateCompareForm.get('ddlVendor')?.value;

                if (hasCustomer && hasVendor) {
                    this.searchtype = 'Customer';
                } else if (hasCustomer) {
                    this.searchtype = 'Customer';
                } else {
                    this.searchtype = 'Tariff';
                }
                break;

            case 'Vendor':
                // Reset and disable ddlCustomer for 'Vendor' selection
                this.rateCompareForm.get('ddlCustomer')?.reset();
                this.rateCompareForm.get('ddlCustomer')?.disable();
                this.searchtype = 'Vendor';
                break;

            default:
                // Handle unexpected cases or provide a default behavior
                this.searchtype = 'Tariff';
                break;
        }
    }


    async searchRates() {
        this.isFormSubmitted = true;
        if (this.rateCompareForm.valid) {
            // get selected id
            // let selectedDestCountryValue = this.rateCompareForm.get('ddlDestinationCountry').value;
            // based on selected id get the country object
            // let selectedDestCountry = this.countryList.filter(x => x.id === selectedDestCountryValue);
            // if (selectedDestCountry.length) {

            // }

            let selectedCustomerValue = this.rateCompareForm.get('ddlCustomer').value;
            let selectedVendorValue = this.rateCompareForm.get('ddlVendor').value;

            if (!selectedCustomerValue && !selectedVendorValue) {
                let msg = `This search will look for Tariff rates since no values are provided for either Customer or Vendor.`;
                this.showConfirmationDialog(msg).then((val) => {
                    if (val) {
                        this.searchtype = 'Tariff';
                        this.getRates();
                    }
                    // console.log(val);
                });
            }
            else if (selectedCustomerValue != null) {
                this.searchtype = 'Customer';
                this.getRates();
            }
            else if (selectedVendorValue != null) {
                this.searchtype = 'Vendor';
                this.getRates();
            }
        }
    }

    getRates() {
        /*const service = this.serviceList.filter(item => item.servicename === this.rateCompareForm.controls.ddlService.value) || null;
        const originCountry = this.countryList.filter(item => item.isocode === this.rateCompareForm.controls.ddlOriginCountry.value) || null;
        const originState = this.originStateList.filter(item => item.isocode === this.rateCompareForm.controls.ddlOriginState.value) || null;
        const originCity = this.originCityList.filter(item => item.isocode === this.rateCompareForm.controls.ddlOriginCity.value) || null;
        const destinationCountry = this.countryList.filter(item => item.isocode === this.rateCompareForm.controls.ddlDestinationCountry.value) || null;
        const destinationState = this.destinationStateList.filter(item => item.isocode === this.rateCompareForm.controls.ddlDestinationState.value) || null;
        const destinationCity = this.destinationCityList.filter(item => item.isocode === this.rateCompareForm.controls.ddlDestinationCity.value) || null;
        */

        let selectedDestinationCountry = this.countryList.filter(x => x.isocode === this.rateCompareForm.get('ddlDestinationCountry').value);
        let selectedDestinationState = this.destinationStateList.filter(x => x.isocode === this.rateCompareForm.get('ddlDestinationState').value);
        let selectedDestinationCity = this.destinationCityList.filter(x => x.isocode === this.rateCompareForm.get('ddlDestinationCity').value);

        let selectedOriginCountry = this.countryList.filter(x => x.isocode === this.rateCompareForm.get('ddlOriginCountry').value);
        let selectedOriginState = this.originStateList.filter(x => x.isocode === this.rateCompareForm.get('ddlOriginState').value);
        let selectedOriginCity = this.originCityList.filter(x => x.isocode === this.rateCompareForm.get('ddlOriginCity').value);

        let selectedVendor = this.rateCompareForm.get('ddlVendor').value ? this.vendorList.filter(x => x.id === this.rateCompareForm.get('ddlVendor').value) : null;
        const applicable_weight = Number(this.rateCompareForm.controls.txtActualWeight.value) > Number(this.rateCompareForm.controls.txtVolumetricWeight.value) ?
            this.rateCompareForm.controls.txtActualWeight.value :
            this.rateCompareForm.controls.txtVolumetricWeight.value;

        const reqObj = {
            searchtype: this.searchtype,
            type: this.activeId === 1 ? 'Customer' : 'Vendor',
            customer: this.rateCompareForm.controls.ddlCustomer.value || null,
            //vendor: this.rateCompareForm.controls.ddlVendor.value || null,
            vendor: selectedVendor,
            service: this.rateCompareForm.controls.ddlService.value,
            product: this.rateCompareForm.controls.ddlProduct.value,
            origincountry: selectedOriginCountry,
            originstate: selectedOriginState,
            origincity: selectedOriginCity,
            originpincode: this.rateCompareForm.controls.txtOriginPincode.value || null,
            destinationcountry: selectedDestinationCountry,
            destinationstate: selectedDestinationState,
            destinationcity: selectedDestinationCity,
            destination_pincode: this.rateCompareForm.controls.txtDestPincode.value,
            weight: applicable_weight,
            bookingdate: this.formateDate(new Date())
            //actual_weight: this.rateCompareForm.controls.txtActualWeight.value,
            //volumetric_weight: this.rateCompareForm.controls.txtVolumetricWeight.value,
        }
        
        // console.log('reqObj', reqObj);
        //const customerId = this.rateCompareForm.controls.ddlCustomer.value;
        this.ngxLoaderService.start();
        try {
            this.rateUploadService.getRateCompare(reqObj).subscribe((res) => {
                if (res && res.success) {
                    // console.log('res success', res);
                    this.rowData = res.data;
                    if (!res.data.length) {
                        this.appCoreService.showMessage(res.message, '', 'info');
                    }
                }
                this.ngxLoaderService.stop();
            });
        } catch (e) {
            this.ngxLoaderService.stop();
            console.log(e);
        }
    }

    async showConfirmationDialog(msg: string) {
        const result = await Swal.fire({
            //   titleText: 'Confirmation',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'Yes',
            showDenyButton: true,
            denyButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });

        if (result.isConfirmed) {
            return true;
        } else {
            return false;
        }
    }

    onChangeRegionalType() {
        const regionalType = this.rateCompareForm.controls.ddlRegionalType.value;
        this.rateCompareForm.reset();
        this.rateCompareForm.controls.ddlRegionalType.setValue(regionalType);
        this.rateCompareForm.controls.ddlRegionalType.value === 'Domestic' ?
            this.rateCompareForm.controls.ddlOriginCountry.setValidators([Validators.required])
            : this.rateCompareForm.controls.ddlOriginCountry.clearValidators();
        this.isFormSubmitted = false;
        this.rateCompareForm.controls.ddlOriginCountry.updateValueAndValidity();
    }

    onNavChange() {
        this.rateCompareForm.reset();
        this.rateCompareForm.controls.ddlRegionalType.setValue(this.defaultType);
        if (this.activeId === 1) {
            this.rateCompareForm.controls.ddlCustomer.setValidators([Validators.required]);
            this.rateCompareForm.controls.ddlVendor.clearValidators();
        } else {
            this.rateCompareForm.controls.ddlVendor.setValidators([Validators.required]);
            this.rateCompareForm.controls.ddlCustomer.clearValidators();
        }
        this.isFormSubmitted = false;
        this.rateCompareForm.controls.ddlCustomer.updateValueAndValidity();
        this.rateCompareForm.controls.ddlVendor.updateValueAndValidity();
    }

    onChangeShipmentType() {
        this.rateCompareForm.controls.ddlProduct.reset();
        const productType = this.rateCompareForm.controls.ddlShipmentType.value;
        this.filteredProductList = productType ? this.productList.filter(product => product.shipmenttype === productType) : this.productList;
    }

    searchOriginPincode: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map((term) =>
                term === ''
                    ? []
                    : this.destPincodeList.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
            ),
        );

    searchDestinationPincode: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map((term) =>
                term === ''
                    ? []
                    : this.originPincodeList.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
            ),
        );
    formatter = (x: { name: string }) => x.name;

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    exportExcel() {
        if (this.rowData.length) {
            console.log('Exporting to excel...');
            // console.log(this.rowData);
            this.excelService.exportAsExcelFile(this.rowData, 'AvailableRates');
        } else {
            this.appCoreService.showMessage('No data to export', '', 'warning');
        }
    }

    resetForm() {
        this.isFormSubmitted = false;
        this.rateCompareForm.reset();
        this.rowData = [];
    }

    formateDate(datetime: any): string {
        try {
            const timestamp = new Date(datetime);
            const year = timestamp.getFullYear();
            const month = (timestamp.getMonth() + 1).toString().padStart(2, '0');
            const day = timestamp.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        } catch (error) {
            console.error('Error occurred during date parsing:', error);
            return '';
        }
    }
}
